const styles = theme => ({
  container: {
    display: "flex",
    flexDirection: "column"
  },
  linearColorPrimary: {
    backgroundColor: "rgba(255,255,255,0.25)"
  },
  linearBarColorPrimary: {
    backgroundColor: "#fff"
  },
  text: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    textAlign: "right",
    paddingRight: theme.spacing.unit * 8,
    paddingBottom: theme.spacing.unit * 2
  },
  titleText: {
    fontFamily: "Oswald",
    fontWeight: 200,
    fontSize: "1.8rem",
    color: theme.palette.common.white
  },
  amountRaised: {
    fontFamily: "Oswald",
    fontWeight: 400,
    fontStyle: "italic",
    fontSize: "8rem",
    lineHeight: "7.5rem",
    color: theme.palette.common.white,
    marginRight: 14,
    textShadow: `${theme.palette.common.white} 0px 0 4px`
  },
  goalBarWrapper: {
    flexBasis: 15,
    backgroundColor: "rgba(255,255,255,0.08)"
  },
  goalBar: {
    height: "100%",
    backgroundColor: "rgba(255,255,255, 0.3)",
    maxWidth: "100%",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.easeOut,
      duration: "1.75s"
    })
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Template/Blocks/EventEarnings/styles.js